<section class="guide">
  <div class="guide__container">
    <div class="guide__header">
      <h2 class="guide__title">{{ 'GUIDE.TITLE' | translate }}</h2>
    </div>
    <div class="guide__cards">
      <lib-card title="GUIDE.CARDS.EASY_EDITOR.TITLE" content="GUIDE.CARDS.EASY_EDITOR.CONTENT" variant="1"> </lib-card>

      <lib-card title="GUIDE.CARDS.EDIT_ANYWHERE.TITLE" content="GUIDE.CARDS.EDIT_ANYWHERE.CONTENT" variant="2">
      </lib-card>

      <lib-card title="GUIDE.CARDS.QUALITY.TITLE" content="GUIDE.CARDS.QUALITY.CONTENT" variant="3"> </lib-card>
    </div>
  </div>
</section>
